import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=e9ae3134&scoped=true&"
import script from "./Basics.vue?vue&type=script&lang=js&"
export * from "./Basics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ae3134",
  null
  
)

export default component.exports